import React, { PropsWithChildren } from 'react';

export function ZaggleIntroSection({ children, heading, icon }: PropsWithChildren<{ heading: string, icon?: string }>) {
  return (<div className={'space-y-10 bg-persian-blue p-10 border-t-2 border-primary'}>
    <div className='text-1.92xl font-bold text-white'>{heading} {icon ? <img src={icon} alt={''} /> : null}</div>
    <div>
      {children}
    </div>
  </div>);
}